import { Injectable } from '@angular/core';
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx-js-style';
import moment from 'moment';
moment.locale('es');
const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const EXCEL_EXTENSION = '.xlsx';
const MIN_COLUMN_WIDTH = 12;
const MAX_COLUMN_WIDTH = 45;

@Injectable()
export class ExportExcelUser {

  constructor() { }

  private normalizeValue(value: any): any {
    if (value === null || value === undefined || value === '') {
      return 'N/A';
    }

    if (typeof value === 'string' && value.trim() === '') {
      return 'N/A';
    }

    if (typeof value === 'number' && Number.isNaN(value)) {
      return 'N/A';
    }

    return value;
  }

  private formatDate(value: any): string {
    if (!value) {
      return 'N/A';
    }

    const date = moment(value);
    return date.isValid() ? date.format('DD/MM/YYYY HH:mm') : 'N/A';
  }

  private normalizeCuit(value: any): any {
    if (!value && value !== 0) {
      return 'N/A';
    }

    const cuit = String(value).replace(/\D/g, '');
    return cuit ? cuit : 'N/A';
  }

  private normalizeEstado(value: any): string {
    const estado = String(value || '').trim();
    const map: { [key: string]: string } = {
      PENDIENTE: 'Pendiente',
      APROBADO: 'Aprobado',
      RECHAZADO: 'Rechazado',
      EN_CURSO: 'En Curso',
      PROCESO_INSPECCION: 'En Curso',
      ASEGURADO: 'Finalizado',
      CERRADO: 'Finalizado',
      FINALIZADO: 'Finalizado',
      ACTIVO: 'Activo',
      INACTIVO: 'Inactivo'
    };

    return map[estado] || (estado || 'N/A');
  }

  public exportAsExcelFile(json: any, excelFileName: string, campaniaSeleccionada: number): void {
    const data = json.flatMap((data: any) => {
      return data.bolsas
        .filter((bolsa: any) => bolsa.campania.id === campaniaSeleccionada)
        .map((bolsa: any) => ({
          'ID': this.normalizeValue(data.id),
          'Usuario': this.normalizeValue(data.name),
          'Cuit': this.normalizeCuit(data.cuit),
          'Email': this.normalizeValue(data.email),
          'Email 2': this.normalizeValue(data.email2),
          'Email 3': this.normalizeValue(data.email3),
          'Email 4': this.normalizeValue(data.email4),
          'Email 5': this.normalizeValue(data.email5),
          'Telefono': this.normalizeValue(data.phoneNumber),
          'Telefono 2': this.normalizeValue(data.phoneNumber2),
          'Telefono 3': this.normalizeValue(data.phoneNumber3),
          'Telefono 4': this.normalizeValue(data.phoneNumber4),
          'Telefono 5': this.normalizeValue(data.phoneNumber5),
          'Rol': this.normalizeValue(data.role),
          'Estado': this.normalizeEstado(data.isActive === true ? 'Activo' : 'Inactivo'),
          'Creado por': this.normalizeValue(data.userPadre ? data.userPadre.name : null),
          'Insumo': this.normalizeValue(bolsa.insumo),
          'Tipo de Cultivo': this.normalizeValue(bolsa.tipoCultivo),
          'Campaña': this.normalizeValue(bolsa.campania?.anio),
          'Cantidad': this.normalizeValue(bolsa.cantidad),
          'Fecha Creación': this.normalizeValue(this.formatDate(data.createdAt)),
        }));
    });
    const myworksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(data);
    this.formatWorksheet(myworksheet);
    const myworkbook: XLSX.WorkBook = { Sheets: { 'data': myworksheet }, SheetNames: ['data'] };
    const excelBuffer: any = XLSX.write(myworkbook, { bookType: 'xlsx', type: 'array' });
    this.saveAsExcelFile(excelBuffer, excelFileName);
  }

  private formatWorksheet(worksheet: XLSX.WorkSheet): void {
    if (!worksheet['!ref']) {
      return;
    }

    const range = XLSX.utils.decode_range(worksheet['!ref']);
    const headerStyle = {
      font: { bold: true, color: { rgb: 'FFFFFF' } },
      fill: { fgColor: { rgb: '1F4E78' } },
      alignment: { horizontal: 'center', vertical: 'center' }
    };

    worksheet['!cols'] = [];

    for (let column = range.s.c; column <= range.e.c; column++) {
      let longestValue = 0;

      for (let row = range.s.r; row <= range.e.r; row++) {
        const cell = worksheet[XLSX.utils.encode_cell({ r: row, c: column })];
        const cellValue = cell && cell.v !== undefined ? String(cell.v) : '';
        longestValue = Math.max(longestValue, cellValue.length);
      }

      const headerCell = worksheet[XLSX.utils.encode_cell({ r: range.s.r, c: column })] as any;
      if (headerCell) {
        headerCell.s = headerStyle;
      }

      worksheet['!cols'][column] = {
        wch: Math.min(Math.max(longestValue + 2, MIN_COLUMN_WIDTH), MAX_COLUMN_WIDTH)
      };
    }

    worksheet['!rows'] = [{ hpt: 24 }];
  }

  public formatBolsas(bolsas: any[], campaniaSeleccionada: number): string {
    let bolsasText = '';
    bolsas.forEach(element => {
      if (element.campania.id == campaniaSeleccionada) {
        bolsasText = bolsasText + ' ' + element.tipoCultivo + ' ' + element.campania.anio + ': ' + element.cantidad + ' ' + element.insumo + ', '
      }
    });
    return bolsasText;
  }

  private saveAsExcelFile(buffer: any, fileName: string): void {
    const data: Blob = new Blob([buffer], {
      type: EXCEL_TYPE
    });
    FileSaver.saveAs(data, fileName + '_exported' + EXCEL_EXTENSION);
  }

}
